export default {
    data() {
        return {

            // 子页标题
            title: '',
            // 当前点击年度索引
            currentIndex: 0,
            index: 0,
            //搜索框内容
            seachText: '',
            // 阻止多次点击
            click: 0,
            //加载状态
            loading: false,
            // 分页器
            currentPage: 1,
            pageSize: 5,
            total: 0,
            order_id: null,
        }
    },
    watch: {
        sections() {
            this.currentIndex = this.sections[this.index].year * 1
            this.title = this.sections[this.index].year * 1
            this.total = this.sections[this.index].total
        }
    },
    methods: {
        // 更换分页器大小
        handleSizeChange(pageSize) {
            this.pageSize = pageSize;
            this.getData();
        },
        // 更换分页器页码
        handleCurrentChange(currentPage) {
            this.currentPage = currentPage;
            this.getData();
        },
        getData() {
            this.loading = true
            let data = {
                shop_id: this.shopID,
                available: 1,
                offset: (this.currentPage - 1) * this.pageSize,
                length: this.pageSize,
                year: this.sections[this.index].year,
                ban_594: 1,

            }
            if (this.seachText) {
                data.category_name = this.seachText;
                this.currentPage = 1;
                this.pageSize = 5;
            }
            this.$post('product_category/search_products', data).then(res => {
                this.sections[this.index].products = res.data.result.data
                this.sections[this.index].total = res.data.result.total
                this.sections.push({})
                this.sections.pop()
                this.loading = false

            })


        },
        // 前端筛选
        searchOldData() {

        },
        //加入购物车
        async addShoppingCart(categoryId, year) {
            if (!this.click) {
                if(year < 2023){
                    this.$message.error('2023年以前的课程暂无法购买')
                    return
                }
                
                this.click = 1;

                // 查出用户state等于2的订单
                let res1 = await this.request1();
                // 取出订单id数组
                let list1 = res1.data.result.data.map(item => item.id);

                // 查询用户的已经购买的，与当前课程包相同的订单id
                let res2 = await this.request2(list1, categoryId);
                let list2 = res2.data.result.data;

                if (list2.length === 0) {
                    // 没有购买过当前的课程包，则判断购物车中有没有当前的课程包
                    let res3 = await this.request3(categoryId);
                    let list3 = res3.data.result.data;

                    // 没有在购物车中，添加到购物车
                    if (list3.length === 0) {

                        // 将课程包添加到购物车中
                        let res4 = await this.request4(categoryId);
                        if (res4.data.status === 'success') {
                            this.$message.success('成功将该课程包添加到购物车中，快去查看吧！')
                            this.$router.push('/shoppingcart')
                            // 重新查询购物车
                            this.request5();
                        }

                    } else {
                        this.$message.warning('该套餐已经在购物车中了，快去购物车中结算吧！');
                    }

                } else {
                    this.$message.warning('您已经购买了该套餐, 快去个人中心查看吧！');
                }

                setTimeout(() => {
                    this.click = 0
                }, 3000)
            }



        },

        // 查出用户state等于2的订单
        request1() {
            return this.$post('orders/paid_order', {
                token: this.$store.state.id,
                offset: 0,
                length: 999
            });
        },

        // 查询用户的已经购买的，与当前课程包相同的订单id
        request2(orderIds, categoryId) {
            return this.$post('category_order/search', {
                category_ids: JSON.stringify([categoryId]),
                order_ids: JSON.stringify(orderIds),
                offset: 0,
                length: 999
            });
        },

        // 查询购物车中与当前课程包相同的数组
        request3(categoryId) {
            return this.$post('shopping_cart/search', {
                token: this.$store.state.id,
                category_ids: JSON.stringify([categoryId]),
                shop_id: this.$store.state.store.id,
                offset: 0,
                length: 999
            });
        },

        // 将课程包添加到购物车中
        request4(categoryId) {
            return this.$post('shopping_cart/create', {
                category_id: categoryId,
                token: this.$store.state.id,
                shop_id: this.$store.state.store.id
            });
        },

        // 重新查询购物车
        request5() {
            this.$post('shopping_cart/search', {
                token: this.$store.state.id,
                offset: 0,
                length: 999,
                shop_id: this.$store.state.store.id
            }).then(res => {
                this.$store.state.shopNum = res.data.result.data.length;
            });
        },

        //换文本内容样式
        currentContent(item, index) {
            this.index = index;
            this.seachText = '';
            this.title = item.year;
            this.currentIndex = item.year;
            this.currentPage = 1;
            this.pageSize = 5;
            this.total = this.sections[this.index].total

            // 如果课程数组不存在则发送请求
            if (!this.sections[this.index].products) {
                this.getData();
            }
        },

        //点击课程跳转到课程详情
        toSection(id, is_project, category_id) {
            if (this.$store.state.id) {
                //如果登录则再判断是否已经购买该课程
                this.$post('users/isPay', {
                    product_id: id,
                    token: this.$store.state.id
                }).then(res => {
                    let query = {
                        id: id,
                        category_id: category_id
                    }

                    // 返回true则没有购买，返回一个数组就说明已经购买
                    // 若已经购买课程则跳转学习页面，若没有则跳转详情页面
                    if (res.data.result != true && is_project == 0) {
                        query.purchased_id = res.data.result[0].purchased_id;
                        query.isPay = 'true';
                    } else {
                        query.isPay = 'false';
                    }
                    let address = this.$router.resolve({
                        path: '/classdetails',
                        query: query
                    });
                    window.open(address.href, "_blank");
                })
            } else {
                //如果没有登录则跳转课程详情
                let address = this.$router.resolve({
                    path: '/classdetails',
                    query: {
                        id: id,
                        category_id: category_id,
                        isPay: 'false'
                    }
                });
                window.open(address.href, "_blank");

            }
        },

        // --------------------------------------------------------------郑州畅和---------------------------------------------------------------------------------------
        zzchBuy(course) {
            // 1. 验证用户是否登录
            if (this.verifyLogin()) {
                // 没有登录, 跳转弹窗登录框
                this.$router.push({
                    path: "/personalcenter"
                });
                return;
            }

            this.$confirm('是否确认开通《' + course.category_name + '》课程', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.isBought(course.id, course.price)
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消'
                });
            });
        },
        isBought: function(id, price) {
            let me = this;
            // console.log(3)
            me.$post('orders/paid_order', {
                token: me.$store.state.id,
                offset: 0,
                length: 999
            }).then(res => {
                // list是用户state等于2的订单数组
                let list = res.data.result.data.map(item => item.id);
                // 发送请求，查看是否已经购买过当前的课程包
                me.$post('category_order/search', {
                    category_ids: JSON.stringify([id]),
                    order_ids: JSON.stringify(list),
                    offset: 0,
                    length: 999
                }).then(res2 => {

                    let list2 = res2.data.result.data;

                    if (list2.length === 0) {
                        me.payMoney(id, price);
                    } else {
                        // 用户购买过该课程包
                        this.$message.error('你已拥有当前课程，请前往个人中心学习')
                    }

                });
            });
        },
        //立即下单
        payMoney: function(id, price) {
            // console.log(4)
            // 发送请求创建订单
            this.$post('orders/create_order', {
                token: this.$store.state.id,
                category_ids: JSON.stringify([id]),
                pay_type: 6,
                invoice_title: '',
                tax_no: '',
                invoice_type: '',
                invoice_email: '',
                invoice_address: '',
                invoice_open_bank: '',
                shop_id: this.$store.state.store.id
            }).then(res => {
                if (res.data.status === 'success') {

                    // 创建订单成功，删除购物车中的对应的数据
                    // 发送请求获取当前的购物车中的对应的数据
                    this.$post('shopping_cart/search', {
                        token: this.$store.state.id,
                        category_ids: JSON.stringify([id]),
                        shop_id: this.$store.state.store.id,
                        offset: 0,
                        length: 999
                    }).then(res2 => {
                        // list是当前用户正在购买的课程包的购物车列表
                        let list = res2.data.result.data.map(item => item.id);

                        // list的长度大于0，有符合条件的购物车数据(同一个用户同一个课程包)，删除数据
                        if (list.length > 0) {
                            for (let i of list) {
                                this.$post('shopping_cart/delete', {
                                    token: this.$store.state.id,
                                    id: i
                                }).then(() => {

                                    // 重新查询购物车
                                    this.$post('shopping_cart/search', {
                                        token: this.$store.state.id,
                                        offset: 0,
                                        length: 999,
                                        shop_id: this.$store.state.store.id
                                    }).then(res => {
                                        this.$store.state.shopNum = res.data.result
                                            .data.length;
                                    });
                                })
                            }
                        }

                    })
                    this.order_id = res.data.result
                    this.goOrderDetails(price)
                    // 跳转到支付页面
                    // this.$router.replace({
                    //     path: '/paycenter',
                    //     query: {
                    //         order_id: res.data.result,
                    //         commodityList: JSON.stringify(this.categoryList)
                    //     }
                    // });

                } else {
                    this.$message.error('下单失败，请稍后重试');
                }
            })

        },
        //选择不同支付方式
        goOrderDetails(price) {
            // console.log(5)
            //获取账户余额
            this.$post('users/profile', {
                token: this.$store.state.id
            }).then(res => {
                let balance = 0;
                if (res.data.status === 'success') {
                    let balance1 = res.data.result.balance;
                    //计算支付后的余额
                    balance = (balance1 * 100 - price * 100) / 100;
                    if (balance < 0) {
                        this.$message({
                            showClose: true,
                            message: '余额不足',
                            type: 'error'
                        });
                    } else {
                        //更新账户余额
                        this.updataBalance(balance, price);

                        // 向余额日志表中插入数据
                        // this.createLog(balance, this.totalprices)
                    }
                }
            })
        },
        //更新账户余额
        updataBalance(balance, price) {
            // console.log(6)
            let orderId = this.order_id;
            // console.log(balance);
            this.$post('users/balance_token', {
                balance: balance,
                token: this.$store.state.id,
                total: price,
                order_id: orderId
            }).then(res => {
                if (res.data.status === 'success') {
                    // 更改订单状态
                    this.updataOrder();
                } else {
                    this.$message({
                        showClose: true,
                        message: '支付失败',
                        type: 'error'
                    });
                }
            })

        },
        // 更改订单状态
        updataOrder() {
            // let date = this.getPayDate()
            // console.log(date)
            let date = new Date(+new Date() + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/,
                '')
            // console.log('当前时间', date)

            this.$post('orders/edit_state', {
                pay_type: 5,
                state: 2,
                id: this.order_id,
                token: this.$store.state.id,
                pay_date: date
            }).then(res => {
                // console.log(res.data.status);
                if (res.data.status === 'success') {
                    this.$message({
                        showClose: true,
                        message: '已成功确认',
                        type: 'success'
                    });
                    this.$router.push('/personalcenter')
                    // this.toPayBtn = true
                    // console.log(this.$route.query.order_id);
                    // this.$router.replace({
                    // 	path: '/myorderdetails',
                    // 	query: {
                    // 		order_id: this.$route.query.order_id,
                    // 		categoryList: this.$route.query.commodityList
                    // 	}
                    // });
                } else {
                    this.$message({
                        showClose: true,
                        message: '订单生成失败',
                        type: 'error'
                    });
                }
            })
        },
        // --------------------------------------------------------------郑州畅和---------------------------------------------------------------------------------------

        // 购买套餐
        buy(categoryId, price) {
            // 1. 验证用户是否登录
            if (this.verifyLogin()) {
                // 没有登录, 跳转弹窗登录框
                this.$router.push({
                    path: "/personalcenter"
                });
                return;
            }

            // 2. 验证用户是否已购买该套餐
            // 请求用户state 为 2 的订单数据
            this.$post('orders/paid_order', {
                token: this.$store.state.id,
                offset: 0,
                length: 999
            }).then(res => {
                let list = res.data.result.data.map(item => item.id);

                // 发送订单数组和课程包id查出关联数据
                this.$post('category_order/search', {
                    category_ids: JSON.stringify([categoryId]),
                    order_ids: JSON.stringify(list),
                    offset: 0,
                    length: 999
                }).then(res2 => {
                    let list2 = res2.data.result.data;

                    if (list2.length === 0) {
                        // 用户没有购买过这个课程包
                        this.$router.push({
                            path: "/pay",
                            query: {
                                commodityList: JSON.stringify([categoryId])
                                // totalprices: price,
                                // categoryId: categoryId
                            }
                        });
                    } else {
                        this.$message.success(
                            "您已经购买了该套餐, 快去个人中心查看吧!"
                        );
                    }
                });
            });
        },

        // 验证用户是否登录
        verifyLogin() {
            return this.$isAbnormal(this.$store.state.id);
        },

        // 取出数组中的productId, 返回productId数组
        getProductList(list) {
            return list.map(item => item.product_id);
        }

    },
    props: {
        sections: Array,
        shopID: Number,
    },
    mounted() {
        // console.log(this.sections, '2')
        // console.log(this.shopID)

    },
    computed: {
        price() {
            let price = 0;
            // this.course.product_category_mapping.map(item => {
            //     price += Number.parseFloat(item.product_price);
            // });
            return price;
        }
    },
}
